export default __webpack_public_path__ + "static/media/theme_sport.1adfb13a.jpg";